module.exports = __webpack_public_path__ + "static/img/part4.2513eed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part4.png
// module id = CEDY
// module chunks = 1